<template>
    <div class="con">
      <div class="one">
         <div class="left">
             <img src="../assets/home/white.png" alt="">
             <div class="icon5">
                 <i class="iconfont icon-facebook"></i>
                 <i class="iconfont icon-tuite"></i>
                 <i class="iconfont icon-ins"></i>
                 <i class="iconfont icon-youtobe" style="font-size:24px;line-height: 20px;"></i>
                 <i class="iconfont icon-google"></i>
             </div>
         </div>
          <div class="nav">
          <div class="right" v-for="(item,index) in $t('foot').rightList" :key="index">
              <p v-for="(i,ind) in item.conList" :key="ind" @click="goto(index,ind)">{{i}}</p>
          </div>
          </div>
          <div class="rightInfo">
              <img src="../assets/home/code.png" alt="">
              <p>{{$t('foot').text1}}</p>
              <p>{{$t('foot').text2}}</p>
          </div>
      </div>
        <div class="two">
         <div class="mainCon">
             <a href="https://beian.miit.gov.cn/" target="_blank">{{$t('foot').text3}}
                        </a>
             <a href="https://www.seniorweb.cn/" target="_blank">{{$t('foot').text4}}</a>
         </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "foot",
        data(){
            return{
                rightList:[
                    {conList:["走进君安", "君安概述","君安沿革","领导关怀","企业荣誉","组织架构"
                        ]},
                    {conList:["君安文化", "君安理念","君安生活","社会责任"]},
                    {conList:["产业布局", "大宗商品运营与管理","实业","投资","建筑服务业"]},
                    {conList:["君安资讯", "公司新闻","行业动态"]},
                    {conList:["人力资源","招聘"]}
                ]
            }
        },
        methods:{
            goto(i,n){
                localStorage.setItem('index',i+1)
                if(i===0 && n===0){
                    this.$router.push({path:'/about'})
                }else if(i===0 && n!==0){
                    this.$router.push({path:'/about',query:{index:n}})
                }else if(i===1 && n===0){
                    this.$router.push({path:'/culture'})
                }else if(i===1 && n!==0){
                    this.$router.push({path:'/culture',query:{index:n}})
                }else if(i===2 && n===0){
                    this.$router.push({path:'/cy'})
                }else if(i===2 && n!==0){
                    this.$router.push({path:'/cy',query:{index:n}})
                }else if(i===3 && n===0){
                    this.$router.push({path:'/news'})
                }else if(i===3 && n!==0){
                    this.$router.push({path:'/news',query:{index:n}})
                }else if(i===4){
                    this.$router.push({path:'/human'})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    background-color: #141720;
    .one{
        width:1440px;
        margin: 0 auto;
        padding: 40px 0;
        display: flex;
        flex-direction: row;
        .left{
            display: flex;
            flex-direction: column;
            width:12%;
            align-items: center;
            padding-top: 60px;
            img{
                width:92px;
                height:79px;
            }
            .icon5{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top: 15px;
                i{
                    color:white;
                    cursor: pointer;
                    transition: all 2s;
                    font-size: 18px;
                }
                i:hover{
                    color:#3B95FF;
                }
            }
        }
        .nav{
              width:73%;
              display: flex;
              flex-direction: row;
              font-size: 12px;
              justify-content: space-between;
              .right{
                  display: flex;
                  flex-direction: column;
                  padding-left: 30px;
                  padding-right: 30px;
                  margin-left: 2%;
                  color:#BABABA;
                  text-align: center;
                  line-height: 30px;
                  p{
                      cursor: pointer;
                      transition: color 2s;
                  }
                  p:first-child{
                      font-size: 14px;
                      color:white;
                      padding-bottom: 10px;
                  }
                  p:hover{
                      color:#3B95FF
                  }
              }
          }
       .rightInfo{
           margin-left: 5%;
           text-align: center;
           color:white;
           font-size: 12px;
           line-height: 30px;
           p{
               transition: all 2s;
           }
           P:hover{
               color:#3B95FF;
           }
       }
    }
    .two{
        width:100%;
        .mainCon{
            width:1280px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin: 0 auto;
            color:white;
            border-top: 1px solid rgba(255,255,255,.2);
            padding: 30px 0;
            font-size: 14px;
            span{
                transition: all 2s;
                cursor: pointer;
            }
            a{
                color:white;
                transition: all 2s;
            }
            span:hover{
                color:#3B95FF;
            }
            a:hover{
                color:#3B95FF;
            }
        }
    }
    @media screen and (max-width:1440px){
        .one{
            width:95%;
        }
        .two{
            .mainCon{
                width:1200px;
            }
        }
    }
    @media screen and (max-width:1279px){
        .one{
            width:95%;
            margin-left: 2.5%;
            flex-direction: column;
            align-items: center;
            padding: 10px 0;
            .left{
                width:90%;
            }
            .nav{
                display: none;
            }
            .rightInfo{
                margin-left: 0;
                margin-top: 30px;
            }
        }
        .two{
            .mainCon{
                width:95%;
                margin-left: 2.5%;
                flex-direction: column;
                align-items: center;
                span{
                    line-height: 30px;
                    padding-bottom: 10px;
                    text-align: center;
                }
            }
        }
    }
}
</style>
